"use client";

import React from "react";
import { formatCurrency } from "utils/currency";
import { useUserPreferences } from "modules/auth/hooks/useUserPreferences";

interface CardGridItemPurchasePriceProps {
  purchasePrice: number | undefined;
}

export function CardGridItemPurchasePrice({
  purchasePrice,
}: CardGridItemPurchasePriceProps) {
  const { preferences } = useUserPreferences();
  if (purchasePrice === undefined || purchasePrice === 0) return null;

  return (
    <div className="text-secondary text-sm">
      ({formatCurrency(purchasePrice, preferences.pricing.currency)})
    </div>
  );
}
